// extracted by mini-css-extract-plugin
export default {"title":"KAwards_title__RrElm","desc":"KAwards_desc__ia-Z0","content":"KAwards_content__iNkTO"};